import { Component } from '@angular/core';
import { RoleService } from '../../../models/users/roleService';
import { Role } from '../../../models/users/role';
import { AccessManager } from '../../ui/access-manager/access-manager';

@Component({
  selector: 'app-role-admin',
  templateUrl: './role-admin.component.html',
  standalone: false,
})
export class RoleAdminComponent {
  selectedRole: Partial<Role> | undefined;
  allNamespaces: string[] = [];

  editingRole: boolean = false;
  canEditRoles: boolean = false;
  allRoles: Role[] = [];
  loading = false;

  constructor(public roleService: RoleService, private accessManager: AccessManager) {}

  ngAfterViewInit() {
    this.loadRoles();
    this.accessManager
      .getUserAccess([
        AccessManager.AUTH_UPDATE_ROLES,
      ])
      .then((oAccess) => {
        this.canEditRoles = oAccess[AccessManager.AUTH_UPDATE_ROLES];
      })
  }

  loadRoles() {
    this.loading = true;
    this.roleService.getAll().then((pageRoles) => {
      this.allRoles = pageRoles.records;
    }).finally(() => this.loading = false);
  }

  select(role: Role) {
    if (!this.canEditRoles) {
      return;
    }

    this.editingRole = true;
    this.selectedRole = role;
  }

  handleRoleSaved(data: any) {
    //user:Partial<User>
    //this.userService.put(data.user, data.accessGrant, data.accessRevoke);
    this.selectedRole = undefined;
    this.editingRole = false;
    this.loadRoles();
  }

  handleRoleCancelled() {
    this.selectedRole = undefined;
    this.editingRole = false;
  }

}
